import React, { memo } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

type SpacingVariable =
    'spacing-base' | 'spacing-base-x1' | 'spacing-base-x2' | 'spacing-base-x3' | 'spacing-base-x4' | 'spacing-base-x6' | 'spacing-base-x8' | 'spacing-base-x9'
    | 'spacing-before-boolean' | 'spacing-after-boolean'
    | 'spacing-before-input' | 'spacing-after-input'
    | 'spacing-before-autocomplete' | 'spacing-after-autocomplete';

interface SpacingProps {
    variable?: SpacingVariable;
}

interface UseSpacingStylesProps {
    variable: SpacingVariable;
}

export const useSpacingStyles = makeStyles<{}, UseSpacingStylesProps>({
    spacing__container: {
        width: '100%',
        height: ({ variable }): string => `var(--${variable})`
    }
});

const Spacing: React.FC<SpacingProps> = memo(({ variable = 'spacing-base' }) => {
    const { spacing__container } = useSpacingStyles({ variable });
    return (
        <div className={spacing__container} />
    );
});

export default Spacing;